import { createValidity } from '@mhub/web-validations';
import { isVietnamCompany } from './vietnam';

// CPI-1220 stores the VN project threshold; booking enforcement belongs to CPI-1248.
export const FOREIGN_PURCHASE_THRESHOLD_MIN = 0;
export const FOREIGN_PURCHASE_THRESHOLD_MAX = 100;
export const FOREIGN_PURCHASE_THRESHOLD_DEFAULT = 0;

export const showsForeignPurchaseThreshold = auth => isVietnamCompany(auth);

// Match the whole input so invalid text is never partially parsed.
const RX_THRESHOLD = /^(\d+\.?\d*|\.\d+)$/;

export const parseForeignPurchaseThreshold = (value) => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }
  if (typeof value !== 'string') {
    return null;
  }
  const trimmed = value.trim();
  if (!RX_THRESHOLD.test(trimmed)) {
    return null;
  }
  const parsed = Number(trimmed);
  return Number.isFinite(parsed) ? parsed : null;
};

export const isValidForeignPurchaseThreshold = (value) => {
  const parsed = parseForeignPurchaseThreshold(value);
  return parsed !== null &&
    parsed >= FOREIGN_PURCHASE_THRESHOLD_MIN &&
    parsed <= FOREIGN_PURCHASE_THRESHOLD_MAX;
};

export const validateForeignPurchaseThreshold = (value, options = {}) => {
  const key = options.key || 'foreignPurchaseThreshold';
  const validity = createValidity(key);
  if (isValidForeignPurchaseThreshold(value)) {
    return validity;
  }
  const label = options.label || 'Threshold %';
  validity.isValid = false;
  validity.message = options.message ||
    `${label} must be a number from ${FOREIGN_PURCHASE_THRESHOLD_MIN} to ${FOREIGN_PURCHASE_THRESHOLD_MAX}`;
  return validity;
};

export const foreignPurchaseThresholdOrDefault = value => (
  value === undefined || value === null ? FOREIGN_PURCHASE_THRESHOLD_DEFAULT : value
);

// A rejected save must leave the input unchanged, including an empty value.
export const foreignPurchaseThresholdSubmission = (auth, value) => {
  if (!showsForeignPurchaseThreshold(auth)) {
    return { omit: true };
  }
  if (!isValidForeignPurchaseThreshold(value)) {
    return { block: true };
  }
  return { value: parseForeignPurchaseThreshold(value) };
};



// WEBPACK FOOTER //
// ./src/utils/foreignPurchaseThreshold.js